export function isAdminUser(role?: string) {
  if (!role) return false;

  return ['Admin', 'SuperAdmin'].includes(role);
}
